import { PlannerHints } from ".";

// From https://github.com/ossc-db/pg_hint_plan/blob/master/docs/hint_list.md
export type HintListType = {
  group: string;
  name: string;
  label: string;
  syntaxExample: string;
  description: string;
};

// Hint is unique by label
// (hint "Leading" has two ways to write, and they have different labels with the same name "Leading")
export const HintList: HintListType[] = [
  {
    group: "Scan method",
    name: "SeqScan",
    label: "SeqScan",
    syntaxExample: "(table)",
    description: "Forces sequential scan on the table.",
  },
  {
    group: "Scan method",
    name: "TidScan",
    label: "TidScan",
    syntaxExample: "(table)",
    description: "Forces TID scan on the table.",
  },
  {
    group: "Scan method",
    name: "IndexScan",
    label: "IndexScan",
    syntaxExample: "(table[ index...])",
    description:
      "Forces index scan on the table. Restricts to specified indexes if any.",
  },
  {
    group: "Scan method",
    name: "IndexOnlyScan",
    label: "IndexOnlyScan",
    syntaxExample: "(table[ index...])",
    description:
      "Forces index-only scan on the table. Restricts to specified indexes if any. Index scan may be used if index-only scan is not available.",
  },
  {
    group: "Scan method",
    name: "BitmapScan",
    label: "BitmapScan",
    syntaxExample: "(table[ index...])",
    description:
      "Forces bitmap scan on the table. Restricts to specified indexes if any.",
  },
  {
    group: "Scan method",
    name: "IndexScanRegexp",
    label: "IndexScanRegexp",
    syntaxExample: "(table[ POSIX Regexp...])",
    description:
      "Forces index scan on the table. Restricts to indexes that matches the specified POSIX regular expression pattern.",
  },
  {
    group: "Scan method",
    name: "IndexOnlyScanRegexp",
    label: "IndexOnlyScanRegexp",
    syntaxExample: "(table[ POSIX Regexp...])",
    description:
      "Forces index-only scan on the table. Restricts to indexes that matches the specified POSIX regular expression pattern.",
  },
  {
    group: "Scan method",
    name: "BitmapScanRegexp",
    label: "BitmapScanRegexp",
    syntaxExample: "(table[ POSIX Regexp...])",
    description:
      "Forces bitmap scan on the table. Restricts to indexes that matches the specified POSIX regular expression pattern.",
  },
  {
    group: "Scan method",
    name: "NoSeqScan",
    label: "NoSeqScan",
    syntaxExample: "(table)",
    description: "Forces to not do sequential scan on the table.",
  },
  {
    group: "Scan method",
    name: "NoTidScan",
    label: "NoTidScan",
    syntaxExample: "(table)",
    description: "Forces to not do TID scan on the table.",
  },
  {
    group: "Scan method",
    name: "NoIndexScan",
    label: "NoIndexScan",
    syntaxExample: "(table)",
    description: "Forces to not do index scan on the table.",
  },
  {
    group: "Scan method",
    name: "NoIndexOnlyScan",
    label: "NoIndexOnlyScan",
    syntaxExample: "(table)",
    description: "Forces to not do index-only scan on the table.",
  },
  {
    group: "Scan method",
    name: "NoBitmapScan",
    label: "NoBitmapScan",
    syntaxExample: "(table)",
    description: "Forces to not do bitmap scan on the table.",
  },
  {
    group: "Join method",
    name: "NestLoop",
    label: "NestLoop",
    syntaxExample: "(table table[ table...])",
    description: "Forces nested loop for the joins on the tables specified.",
  },
  {
    group: "Join method",
    name: "HashJoin",
    label: "HashJoin",
    syntaxExample: "(table table[ table...])",
    description: "Forces hash join for the joins on the tables specified.",
  },
  {
    group: "Join method",
    name: "MergeJoin",
    label: "MergeJoin",
    syntaxExample: "(table table[ table...])",
    description: "Forces merge join for the joins on the tables specified.",
  },
  {
    group: "Join method",
    name: "NoNestLoop",
    label: "NoNestLoop",
    syntaxExample: "(table table[ table...])",
    description:
      "Forces to not do nested loop for the joins on the tables specified.",
  },
  {
    group: "Join method",
    name: "NoHashJoin",
    label: "NoHashJoin",
    syntaxExample: "(table table[ table...])",
    description:
      "Forces to not do hash join for the joins on the tables specified.",
  },
  {
    group: "Join method",
    name: "NoMergeJoin",
    label: "NoMergeJoin",
    syntaxExample: "(table table[ table...])",
    description:
      "Forces to not do merge join for the joins on the tables specified.",
  },
  {
    group: "Join order",
    name: "Leading",
    label: "Leading (tables)",
    syntaxExample: "(table table[ table...])",
    description: "Forces join order as specified.",
  },
  {
    group: "Join order",
    name: "Leading",
    label: "Leading (join pair)",
    syntaxExample: "(<join pair>)",
    description:
      "Forces join order and directions as specified. A join pair is a pair of tables and/or other join pairs enclosed by parentheses, which can make a nested structure.",
  },
  {
    group: "Behavior control on Join",
    name: "Memoize",
    label: "Memoize",
    syntaxExample: "(table table[ table...])",
    description:
      "Allows the topmost join of a join among the specified tables to Memoize the inner result. Not enforced.",
  },
  {
    group: "Behavior control on Join",
    name: "NoMemoize",
    label: "NoMemoize",
    syntaxExample: "(table table[ table...])",
    description:
      "Inhibits the topmost join of a join among the specified tables from Memoizing the inner result.",
  },
  {
    group: "Row number correction",
    name: "Rows",
    label: "Rows",
    syntaxExample: "(table table[ table...] correction)",
    description:
      "Corrects row number of a result of the joins on the tables specified. The available correction methods are absolute (#), addition (+), subtract (-) and multiplication (*). should be a string that strtod() can understand.",
  },
  {
    group: "Parallel query configuration",
    name: "Parallel",
    label: "Parallel",
    syntaxExample: "(table <# of workers> [soft|hard])",
    description:
      "Enforces or inhibits parallel execution of the specified table. <# of workers> is the desired number of parallel workers, where zero means inhibiting parallel execution. If the third parameter is soft (default), it just changes max_parallel_workers_per_gather and leaves everything else to the planner. Hard enforces the specified number of workers.",
  },
  {
    group: "GUC",
    name: "Set",
    label: "Set",
    syntaxExample: "(GUC-param value)",
    description:
      "Sets GUC parameter to the value defined while planner is running.",
  },
];

export const GroupedHintList = HintList.reduce<Record<string, HintListType[]>>(
  (acc, item) => {
    if (!acc[item.group]) {
      acc[item.group] = [];
    }
    acc[item.group].push(item);
    return acc;
  },
  {},
);

export function extractPlannerHints(query: string): PlannerHints {
  // Match the first /*+ ... */ hint block
  const hintBlockMatch = query.match(/\/\*\+\s*([^*]+)\*\//);
  if (!hintBlockMatch) {
    return [];
  }

  const hintContent = hintBlockMatch[1].trim();

  const hintNames = HintList.map((hint) => hint.name).join("|");
  // Match each hint in the block: e.g. SeqScan(t1) IndexScan(t2 t2_pkey)
  // Note: currently, this doesn't support more than 2 nested parentheses (e.g. (((t1) t2) t3) is not supported)
  const hintPattern = new RegExp(
    `\\b(${hintNames})\\s*(\\((?:[^()]*|\\([^()]*\\))*\\))`,
    "g",
  );

  const hints: PlannerHints = [];
  let match: RegExpExecArray | null;

  while ((match = hintPattern.exec(hintContent)) !== null) {
    // Remove any spaces around parentheses
    const value = match[2].replace(/\(\s*/g, "(").replace(/\s*\)/g, ")");
    hints.push({ name: match[1], value: value });
  }

  return hints;
}

export function formatPlannerHints(query: string, hints: PlannerHints) {
  // Remove hints completely first
  const newQuery = query.replace(/\/\*\+[\s\S]*?\*\/\s*/g, "");
  if (hints.length === 0) {
    return newQuery;
  }
  // Create hints comment from hints
  const hintComment = hints
    .map((hint) => `${hint.name}${hint.value}`)
    .join(" ");
  return `/*+ ${hintComment} */\n${newQuery}`;
}
